import clsx from 'clsx';
import {
  Checkbox, FormControl, IconButton,
  FormControlLabel,
  InputAdornment, makeStyles, MenuItem, OutlinedInput, Select,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import SpinningIconLabelButton from '../../../components/Buttons/SpinningIconLabelButton';
import { Add, Close, Edit, ExpandLess, Label, ThumbDown, ThumbUp } from '@material-ui/icons';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import { FormattedMessage, useIntl } from 'react-intl';
import AttachedFilesList from '../../../components/Files/AttachedFilesList';
import React, { useContext, useState } from 'react';
import { Assignments, rejectInvestible, useCollaborators } from './PlanningInvestible';
import { DiffContext } from '../../../contexts/DiffContext/DiffContext';
import { NotificationsContext } from '../../../contexts/NotificationsContext/NotificationsContext';
import { InvestiblesContext } from '../../../contexts/InvestibesContext/InvestiblesContext';
import { MarketStagesContext } from '../../../contexts/MarketStagesContext/MarketStagesContext';
import { CommentsContext } from '../../../contexts/CommentsContext/CommentsContext';
import { findMessageOfType, findMessageOfTypeAndId, findMessagesForInvestibleId } from '../../../utils/messageUtils';
import { isInInbox } from '../../../contexts/NotificationsContext/notificationsContextHelper';
import { deleteOrDehilightMessages } from '../../../api/users';
import { getDiff } from '../../../contexts/DiffContext/diffContextHelper';
import { getStagesInfo } from '../../../utils/stageUtils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import {
  attachFilesToInvestible,
  deleteAttachedFilesFromInvestible,
  stageChangeInvestible,
  updateInvestible
} from '../../../api/investibles';
import { onInvestibleStageChange } from '../../../utils/investibleFunctions';
import { UNASSIGNED_TYPE } from '../../../constants/notifications';
import {
  getAcceptedStage,
  getFullStage,
  getStageNameForId,
  getStages,
  isAcceptedStage,
  isFurtherWorkStage,
  isInReviewStage
} from '../../../contexts/MarketStagesContext/marketStagesContextHelper';
import { addInvestible, refreshInvestibles } from '../../../contexts/InvestibesContext/investiblesContextHelper';
import { OperationInProgressContext } from '../../../contexts/OperationInProgressContext/OperationInProgressContext';
import { MarketPresencesContext } from '../../../contexts/MarketPresencesContext/MarketPresencesContext';
import { formWizardLink, navigate } from '../../../utils/marketIdPathFunctions';
import {
  APPROVAL_WIZARD_TYPE,
  IN_PROGRESS_WIZARD_TYPE,
  JOB_APPROVERS_WIZARD_TYPE,
  JOB_ASSIGNEE_WIZARD_TYPE,
  JOB_COLLABORATOR_WIZARD_TYPE,
  JOB_STAGE_WIZARD_TYPE
} from '../../../constants/markets';
import { useHistory } from 'react-router';
import InvesibleCommentLinker from '../../Dialog/InvesibleCommentLinker';
import {
  getGroupPresences,
  useGroupPresences
} from '../../../contexts/MarketPresencesContext/marketPresencesHelper';
import { useAddressed } from '../../../utils/votingUtils';
import { GroupMembersContext } from '../../../contexts/GroupMembersContext/GroupMembersContext';
import { getMidnightToday } from '../../../utils/timerUtils';
import _ from 'lodash';
import { removeMessages } from '../../../contexts/NotificationsContext/notificationsContextReducer';
import { DaysEstimate } from '../../../components/AgilePlan/DaysEstimate';
import { ISSUE_TYPE, QUESTION_TYPE, SUGGEST_CHANGE_TYPE, TODO_TYPE } from '../../../constants/comments';
import { MarketGroupsContext } from '../../../contexts/MarketGroupsContext/MarketGroupsContext';
import { addMarketComments, getInvestibleComments } from '../../../contexts/CommentsContext/commentsContextHelper';
import { requiresAction } from '../../../components/AddNewWizards/JobStage/JobStageWizard';
import GravatarGroup from '../../../components/Avatars/GravatarGroup';
import { NAME_MAX_LENGTH } from '../../../components/TextFields/NameField';
import { DARK_ACTION_BUTTON_COLOR } from '../../../components/Buttons/ButtonConstants';
import { ThemeModeContext } from '../../../contexts/ThemeModeContext';
import PokeAIButton from '../../../components/Buttons/PokeAIButton';
import useDoableStageGuard from '../../../components/AddNewWizards/JobStage/useDoableStageGuard';
import { getUnresolvedAIQuestions } from '../../../utils/commentFunctions';
import { nextStageField } from '../../../utils/nextStageField';

const useStyles = makeStyles(
  () => ({
    myCheckbox: {
      '& .MuiSvgIcon-root': {
        scale: '1.4'
      },
    },
  }),
  { name: "PlanningInvestibleNav" }
);
export default function PlanningInvestibleNav(props) {
  const { name, marketInvestible, classes, userId, isAssigned, labels,
    pageState, marketPresences, assigned, isInVoting, investibleComments, marketInfo, marketId,
    updatePageState, investibleId, yourVote, openInlineWizard } = props;
  const confirmDoableQuestions = useDoableStageGuard(marketId);
  const intl = useIntl();
  const history = useHistory();
  const [themeMode] = useContext(ThemeModeContext);
  const isDark = themeMode === 'dark';
  const [labelDraft, setLabelDraft] = useState('');
  const [editingLabel, setEditingLabel] = useState(false);
  const [, investiblesDispatch] = useContext(InvestiblesContext);
  const [messagesState, messagesDispatch] = useContext(NotificationsContext);
  const [operationRunning, setOperationRunning] = useContext(OperationInProgressContext);
  const [, diffDispatch] = useContext(DiffContext);
  const [marketPresencesState, marketPresencesDispatch] = useContext(MarketPresencesContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [groupPresencesState] = useContext(GroupMembersContext);
  const [commentsState, commentsDispatch] = useContext(CommentsContext);
  const [groupsState] = useContext(MarketGroupsContext);
  const styles = useStyles();
  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down('xs'));
  const { stage, required_approvers:  requiredApprovers, open_for_investment: openForInvestment, is_visible: isVisible,
    accepted, group_id: groupId, completion_estimate: marketDaysEstimate } = marketInfo;
  const groupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId, groupId) || [];
  const addressed = useAddressed(groupPresences, investibleId, marketId);
  const fullStage = getFullStage(marketStagesState, marketId, stage) || {};
  const canEditLabel = isInReviewStage(fullStage);
  const showLabelEditor = editingLabel && canEditLabel;
  const attachedFiles =  marketInvestible?.investible?.attached_files;
  // No quick add from your vote so have to check that as well
  const unaccepted = isAssigned && !accepted?.includes(userId) && (!isAssigned || _.isEmpty(yourVote));
  const labelsSorted = _.reverse(_.sortBy(labels, "updated_at"));
  const label = _.isEmpty(labelsSorted) ? undefined : labelsSorted[0].label;
  const labelEditorId = `label${investibleId}`;
  const LabelActionIcon = showLabelEditor ? Close : _.isEmpty(label) ? Add : Edit;
  const labelActionText = intl.formatMessage({id: showLabelEditor ? 'cancel' :
    _.isEmpty(label) ? 'addJobLabel' : 'editJobLabel'});

  function onDeleteFile(path) {
    return deleteAttachedFilesFromInvestible(marketId, investibleId, [path]).then((investible) => {
      addInvestible(investiblesDispatch, diffDispatch, investible);
      setOperationRunning(false);
    });
  }

  function onAttachFiles(metadatas) {
    return attachFilesToInvestible(marketId, investibleId, metadatas)
      .then((investible) => addInvestible(investiblesDispatch, diffDispatch, investible));
  }

  const stagesInfo = getStagesInfo(marketId, marketStagesState, stage);
  const {
    isInAccepted,
    isFurtherWork
  } = stagesInfo;
  const addressedIds = (addressed || []).filter((address) => !address.abstain)
    .map((address) => address.id);
  const investibleCollaborators = useCollaborators(marketPresences, investibleComments, marketPresencesState,
    investibleId, marketId, true);
  const assignedNotAccepted = assigned.filter((assignee) => !(accepted || []).includes(assignee));
  const reportMessage = findMessageOfType('REPORT_REQUIRED', investibleId, messagesState);
  const jobInboxMessages = findMessagesForInvestibleId(investibleId, messagesState.messages)
    .filter((message) => isInInbox(message));
  const unaccceptedMessage = findMessageOfType('UNREAD_JOB_APPROVAL_REQUEST', investibleId, messagesState);
  const estimateMessage = findMessageOfType('UNREAD_ESTIMATE', investibleId, messagesState) || 
    findMessageOfType('REPORT_REQUIRED', investibleId, messagesState);
  const hasBlockingIssue = !_.isEmpty(investibleComments.find((comment) => comment.comment_type === ISSUE_TYPE
    && !comment.resolved && !comment.deleted))
  const tasksInProgress = investibleComments.find((comment) => !comment.resolved && !comment.deleted && 
    comment.comment_type === TODO_TYPE && comment.in_progress);
  const allowableGroups = groupsState[marketId]?.filter((group) => {
    if (_.isEmpty(assigned)) {
      return true;
    }
    const thisGroupPresences = getGroupPresences(marketPresences, groupPresencesState, marketId, group.id) || [];
    return !_.isEmpty(thisGroupPresences.filter((presence) => assigned.includes(presence.id)));
  });

  function requiresCloseComments(fullMoveStage) {
    const openTodos = investibleComments.find((comment) => comment.comment_type === TODO_TYPE && !comment.resolved);
    const openAssistance = investibleComments.find((comment) => !comment.resolved &&
      [QUESTION_TYPE, SUGGEST_CHANGE_TYPE, ISSUE_TYPE].includes(comment.comment_type));
    const hasOpenTodos = !_.isEmpty(openTodos) && isInReviewStage(fullMoveStage);
    return hasOpenTodos || (isAcceptedStage(fullMoveStage) &&
      getUnresolvedAIQuestions(investibleComments, marketPresencesState[marketId]).length > 0) ||
      (fullStage.move_on_comment && openAssistance && !fullMoveStage.close_comments_on_entrance &&
        !isFurtherWorkStage(fullMoveStage));
  }

  function setReadyToStart(isReadyToStart) {
    const updateInfo = {
      marketId,
      investibleId,
      openForInvestment: isReadyToStart,
    };
    setOperationRunning(`readyToStartCheckbox${investibleId}`);
    return updateInvestible(updateInfo).then((fullInvestible) => {
      onInvestibleStageChange(stage, fullInvestible, investibleId, marketId, undefined,
        undefined, investiblesDispatch, diffDispatch, marketStagesState, [UNASSIGNED_TYPE],
        fullStage);
      setOperationRunning(false);
    });
  }

  function setIsVisible(isVisible) {
    const updateInfo = {
      marketId,
      investibleId,
      isVisible
    };
    setOperationRunning(`isVisibleCheckbox${investibleId}`);
    return updateInvestible(updateInfo).then((fullInvestible) => {
      refreshInvestibles(investiblesDispatch, diffDispatch, [fullInvestible]);
      setOperationRunning(false);
    });
  }

  function toggleLabelEditor() {
    setLabelDraft(label || '');
    setEditingLabel(!editingLabel);
  }

  function updateLabel() {
    const updateInfo = {
      marketId,
      investibleId,
      labelList: [labelDraft]
    };
    return updateInvestible(updateInfo).then((fullInvestible) => {
      refreshInvestibles(investiblesDispatch, diffDispatch, [fullInvestible]);
      setEditingLabel(false);
    }).finally(() => setOperationRunning(false));
  }


  function myRejectInvestible() {
    return rejectInvestible(marketId, investibleId, marketInvestible, commentsState, commentsDispatch,
      investiblesDispatch, diffDispatch, marketStagesState, marketPresencesDispatch);
  }

  function handleDateChange(rawDate) {
    const date = getMidnightToday(rawDate);
    const daysEstimate = marketDaysEstimate ? new Date(marketDaysEstimate) : undefined;
    if (!_.isEqual(date, daysEstimate)) {
      const updateInfo = {
        marketId,
        investibleId,
        daysEstimate: date,
      };
      setOperationRunning(true);
      return updateInvestible(updateInfo).then((fullInvestible) => {
        refreshInvestibles(investiblesDispatch, diffDispatch, [fullInvestible]);
        if (reportMessage) {
          messagesDispatch(removeMessages([reportMessage.type_object_id]));
        }
        setOperationRunning(false);
      });
    }
  }
  const readyToStartChecked = operationRunning === `readyToStartCheckbox${investibleId}` ?
    !openForInvestment : openForInvestment;
  const isVisibleChecked = operationRunning === `isVisibleCheckbox${investibleId}` ?
    !isVisible : isVisible;
  const isSingleUser = useGroupPresences(groupId, marketId, marketPresences);

  function assignToSingleUser() {
    const fullMoveStage = getAcceptedStage(marketStagesState, marketId);
    if (confirmDoableQuestions(investibleId, fullMoveStage.id, userId)) {
      return Promise.resolve(false);
    }
    const moveInfo = {
      marketId,
      investibleId,
      stageInfo: {
        current_stage_id: marketInfo.stage,
        stage_id: fullMoveStage.id,
        assignments: [userId]
      },
    };
    return stageChangeInvestible(moveInfo)
      .then((newInv) => {
        onInvestibleStageChange(fullMoveStage.id, newInv, investibleId, marketId, commentsState,
          commentsDispatch, investiblesDispatch, () => {}, marketStagesState, undefined,
          fullStage, marketPresencesDispatch);
        setOperationRunning(false);
      });
  }

  function changeInvestibleView(newGroupId) {
    setOperationRunning(true);
    const updateInfo = {
      marketId,
      investibleId,
      groupId: newGroupId,
    };
    return updateInvestible(updateInfo)
      .then((fullInvestible) => {
        const investibleComments = getInvestibleComments(investibleId, marketId, commentsState);
        const investibleCommentsMoved = investibleComments.map((comment) => {
          return {...comment, group_id: newGroupId}
        });
        addMarketComments(commentsDispatch, marketId, investibleCommentsMoved);
        refreshInvestibles(investiblesDispatch, diffDispatch, [fullInvestible]);
        setOperationRunning(false);
      });
  }

  return (
    <>
      {!mobileLayout && (
        <div style={{ maxWidth: '11rem', width: '100%', wordWrap: 'break-word', marginBottom: 0 }}>
          {name}
        </div>
      )}
      <InvesibleCommentLinker investibleId={investibleId} marketId={marketId} flushLeft textColor={isDark ? 'white' : undefined} />
      {!!marketInfo.ticket_code && (
        <div style={{display: 'flex'}}>
          <PokeAIButton
            marketId={marketId}
            ticketCode={marketInfo.ticket_code}
            id={`pokeAIJob${investibleId}`}
            useDark={isDark}
          />
        </div>
      )}
      {/* https://stage.uclusion.com/dd56682c-9920-417b-be46-7a30d41bc905/Q-all-706
          Q-all-706 O-1: always show, disable when this user has nothing to clear. */}
      <div style={{display: 'flex'}}>
        <SpinningIconLabelButton
          id={`inboxClearJob${investibleId}`}
          icon={DeleteSweepIcon}
          iconColor={isDark ? DARK_ACTION_BUTTON_COLOR : undefined}
          useDark={isDark}
          disabled={_.isEmpty(jobInboxMessages)}
          onClick={() => deleteOrDehilightMessages(jobInboxMessages, messagesDispatch, true, false, true)
            .finally(() => setOperationRunning(false))}
        >
          {intl.formatMessage({ id: 'jobNavClearNotifications' })}
        </SpinningIconLabelButton>
      </div>
      {isInAccepted && (
        <DaysEstimate marketId={marketId} onChange={handleDateChange} value={marketDaysEstimate}
                      isAssigned={isAssigned} estimateMessage={estimateMessage} />
      )}
      <MarketMetaData
        stagesInfo={stagesInfo}
        investibleId={investibleId}
        marketId={marketId}
        pageState={pageState}
        updatePageState={updatePageState}
        requiresCloseComments={requiresCloseComments}
        stageId={stage}
        formerStageId={marketInfo.former_stage_id}
        assigned={assigned}
        isAssigned={isAssigned}
        isSingleUser={isSingleUser}
        userId={userId}
        tasksInProgress={tasksInProgress}
      />
      {marketId && (
        <div className={clsx(classes.group, classes.assignments)}>
          <div className={classes.assignmentContainer}>
            <Assignments
              classes={classes}
              marketPresences={marketPresences}
              assigned={assigned}
              unaccceptedMessage={unaccceptedMessage}
              unaccceptedList={isInVoting ? assignedNotAccepted : undefined}
              toggleIconButton={isSingleUser ? (_.isEmpty(assigned) ? assignToSingleUser : undefined) :
                () => navigate(history, formWizardLink(JOB_ASSIGNEE_WIZARD_TYPE, marketId, investibleId))}
              assignmentColumnMessageId='planningInvestibleAssignments'
              toolTipId='storyAddParticipantsLabel'
            />
          </div>
        </div>
      )}
      {unaccepted && (
        <div style={{display: 'flex'}}>
          <SpinningIconLabelButton
            doSpin={false}
            onClick={() => openInlineWizard
              ? openInlineWizard({ wizardType: APPROVAL_WIZARD_TYPE, marketId, investibleId, groupId })
              : navigate(history, formWizardLink(APPROVAL_WIZARD_TYPE, marketId, investibleId, groupId))}
            icon={ThumbUp} iconColor={isDark ? DARK_ACTION_BUTTON_COLOR : undefined} id='accept'>
            {intl.formatMessage({ id: 'accept' })}
          </SpinningIconLabelButton>
        </div>
      )}
      {unaccepted && (
        <div style={{display: 'flex'}}>
          <SpinningIconLabelButton onClick={myRejectInvestible} icon={ThumbDown} 
             iconColor={isDark ? DARK_ACTION_BUTTON_COLOR : undefined} id='reject'>
            {intl.formatMessage({ id: 'reject' })}
          </SpinningIconLabelButton>
        </div>
      )}
      {marketId && marketInvestible.investible && isFurtherWork && (
        <div className={classes.assignmentContainer}>
          {hasBlockingIssue && (
            <Typography variant="body2">
              {intl.formatMessage({ id: 'blockingIssueCheckboxExplanation' })}
            </Typography>
          )}
          {!hasBlockingIssue && (
            <Tooltip key='readyToStartCheckboxKey'
                     title={<FormattedMessage id='assignReadyJobsToolTip' />}>
              <FormControlLabel
                id='readyToStartCheckbox'
                style={{marginLeft: '0.25rem'}}
                control={
                  <Checkbox
                    id={`readyToStartCheckbox${investibleId}`}
                    value={openForInvestment}
                    className={styles.myCheckbox}
                    // B-all-474: match the comment card checkboxes - secondary "green" glyph over a
                    // constant white backing so the check mark reads white. Inline color also wins
                    // over the theme's faint disabled color, so the box can no longer go black
                    // while an operation is running or offline.
                    style={{color: theme.palette.secondary.main, backgroundColor: 'white',
                      padding: 0, borderRadius: 0}}
                    disabled={operationRunning !== false}
                    checked={readyToStartChecked}
                    onClick={() => setReadyToStart(!openForInvestment)}
                  />
                }
                label={<Typography variant="body2" style={{marginLeft: '0.8rem'}}>
                  {intl.formatMessage({ id: 'readyToStartCheckboxExplanation' })}</Typography>}
              />
            </Tooltip>
          )}
        </div>
      )}
      {!_.isEmpty(investibleCollaborators.filter((collaborator) => !assigned?.includes(collaborator.id))) && (
        <div className={clsx(classes.group, classes.assignments)}>
          <div className={classes.assignmentContainer}>
            <Tooltip
              title={intl.formatMessage({ id: 'collaboratorsExplanation' })}>
              <b><FormattedMessage id="collaborators"/></b>
            </Tooltip>
            <GravatarGroup users={investibleCollaborators} gravatarClassName={classes.smallGravatar} />
          </div>
        </div>
      )}
      {marketId && isInVoting && (
        <div className={clsx(classes.group, classes.assignments)}>
          <div className={classes.assignmentContainer}>
            <Assignments
              classes={classes}
              marketPresences={marketPresences}
              assigned={requiredApprovers}
              toolTipId="storyApproversLabel"
              toggleIconButton={() => navigate(history,
                formWizardLink(JOB_APPROVERS_WIZARD_TYPE, marketId, investibleId))}
              assignmentColumnMessageId='requiredApprovers'
            />
          </div>
        </div>
      )}
      {_.size(marketPresences) > 1 && _.size(marketPresences) > _.size(groupPresences) && (
        <div className={clsx(classes.group, classes.assignments)}>
          <div className={classes.assignmentContainer}>
            <Assignments
              classes={classes}
              marketPresences={marketPresences}
              assigned={addressedIds}
              toolTipId='storyAddressedLabel'
              toggleIconButton={() => navigate(history,
                formWizardLink(JOB_COLLABORATOR_WIZARD_TYPE, marketId, investibleId))}
              assignmentColumnMessageId='addressed'
            />
          </div>
        </div>
      )}
      {_.size(allowableGroups) > 1 && groupId && (
        <FormControl>
          <div className={classes.sectionTitle}>
            <FormattedMessage id="switchGroup"/>
          </div>
            <Select
              value={groupId}
              onChange={(event) => changeInvestibleView(event.target.value)}
            >
              {allowableGroups.map((group) => {
                return <MenuItem key={`key${group.id}`} value={group.id}>{group.name}</MenuItem>
              })}
            </Select>
        </FormControl>
      )}
      {(!_.isEmpty(label) || canEditLabel) && (
        <div style={{marginBottom: '1rem'}}>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <b><FormattedMessage id='label'/></b>
            {canEditLabel && (
              <div style={{marginTop: '-0.3rem'}}>
                <Tooltip placement='top' title={labelActionText}>
                  <span style={{display: 'inline-flex'}}>
                    <IconButton
                      size='small'
                      disabled={operationRunning !== false}
                      id={`editLabel${investibleId}`}
                      aria-label={labelActionText}
                      onClick={toggleLabelEditor}
                    >
                      <LabelActionIcon htmlColor={isDark ? DARK_ACTION_BUTTON_COLOR : 'black'} fontSize='small' />
                    </IconButton>
                  </span>
                </Tooltip>
              </div>
            )}
          </div>
          {!showLabelEditor && !_.isEmpty(label) && (
            <Typography variant="body2" style={{maxWidth: '10rem'}}>
              {label}
            </Typography>
          )}
          {showLabelEditor && (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
              <OutlinedInput
                id={labelEditorId}
                value={labelDraft}
                onChange={(event) => setLabelDraft(event.target.value)}
                style={{marginBottom: '10px', width: '100%', maxWidth: '10rem'}}
                inputProps={{maxLength: NAME_MAX_LENGTH, 'aria-label': intl.formatMessage({id: 'label'})}}
                endAdornment={
                  <InputAdornment position='end' style={{marginRight: '1rem'}}>
                    {NAME_MAX_LENGTH - labelDraft.length}
                  </InputAdornment>
                }
              />
              <SpinningIconLabelButton
                style={{alignSelf: 'flex-start'}}
                iconColor={isDark ? DARK_ACTION_BUTTON_COLOR : undefined}
                disabled={_.isEmpty(labelDraft) && _.isEmpty(label)}
                onClick={updateLabel}
                autoFocus={false}
                icon={Label} id={`updateLabel${investibleId}`}>
                {intl.formatMessage({id: 'update'})}
              </SpinningIconLabelButton>
            </div>
          )}
        </div>
      )}
      <div className={classes.assignmentContainer}>
          <Tooltip key='isVisibleCheckboxKey'
                    title={<FormattedMessage id='isVisibleJobToolTip' />}>
            <FormControlLabel
              id='isVisibleCheckbox'
              style={{marginLeft: '0.25rem'}}
              control={
                <Checkbox
                  id={`isVisibleCheckbox${investibleId}`}
                  value={isVisible}
                  className={styles.myCheckbox}
                  // B-all-474: same treatment as the ready-to-start checkbox above.
                  style={{color: theme.palette.secondary.main, backgroundColor: 'white',
                    padding: 0, borderRadius: 0}}
                  disabled={operationRunning !== false}
                  checked={isVisibleChecked} 
                  onClick={() => setIsVisible(!isVisibleChecked)}
                />
              }
              label={<Typography variant="body2" style={{marginLeft: '0.8rem'}}>
                {intl.formatMessage({ id: 'isAIAbleExplanation' })}</Typography>}
            />
          </Tooltip>
        </div>
      <AttachedFilesList
        marketId={marketId}
        onUpload={onAttachFiles}
        onDeleteClick={onDeleteFile}
        attachedFiles={attachedFiles}
      />
    </>
  );
}

export const useMetaDataStyles = makeStyles(
  theme => {
    return {
      root: {
        alignItems: "flex-start",
        display: "flex",
        flexDirection: 'column',
        width: '100%',
        '& > div': {
          borderRadius: '6px',
          marginBottom: '1rem'
        }
      },
      flexRow: {
        flexDirection: 'row'
      },
      archivedColor: {
        color: '#ffC000',
      },
      normalColor: {
      },
      archived: {
        color: '#ffC000',
        fontSize: 12,
      },
      highlighted: {
        color: 'red',
        fontSize: 12,
      },
      normal: {
        fontSize: 14,
        wordBreak: 'break-word',
      },
      group: {
        backgroundColor: '#ecf0f1',
        borderRadius: 6,
        display: "flex",
        flexDirection: "row",
        padding: theme.spacing(1, 1),
        "&:first-child": {
          marginLeft: 0
        },
        [theme.breakpoints.down("sm")]: {
          backgroundColor: '#fff',
        }
      },
      expiration: {
        "& dd": {
          alignItems: "center",
          display: "flex",
          flex: "1 auto",
          flexDirection: "row",
          fontWeight: "bold",
          [theme.breakpoints.down('sm')]: {
            margin: 0,
          },

        }
      },
      blue: {
        backgroundColor: '#2d9cdb',
      },
      expansionControl: {
        backgroundColor: '#ecf0f1',
        width: '100%'
      },
      fontControl: {
        alignItems: "center",
        textTransform: 'capitalize',
        marginRight: 'auto',
        marginLeft: '5px',
        fontWeight: 700
      },
      expirationProgress: {
        marginRight: theme.spacing(1)
      },
      assignments: {
        padding: 0,
        "& ul": {
          flex: 4,
          margin: 0,
          padding: 0
        },
        "& li": {
          display: "inline-flex",
          fontWeight: "bold",
          marginLeft: theme.spacing(1)
        }
      },
      assignmentContainer: {
        width: '100%',
        textTransform: 'capitalize'
      },
      assignIconContainer: {
        display: 'flex',
        justifyContent: 'center'
      },
      assignmentFlexRow: {
        width: '100%',
        display: 'flex',
        padding: '8px'
      },
      flex1: {
        flex: 1
      },
      noPad: {
        padding: 0
      },
      menuButton: {
        width: '100%',
        padding: '12px'
      },
      linkContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
      },
      scrollContainer: {
        maxHeight: '210px',
        overflow: 'auto',
      },
      outerBorder: {
        border: '1px solid black',
        borderRadius: '6px 6px 0 0'
      },
      actionPrimary: {
        backgroundColor: '#2D9CDB',
        color: 'white',
        textTransform: 'unset',
        marginRight: '20px',
        '&:hover': {
          backgroundColor: '#e0e0e0'
        },
        '&:disabled': {
          color: 'white',
          backgroundColor: 'rgba(45, 156, 219, .6)'
        }
      },
      actionSecondary: {
        backgroundColor: '#e0e0e0',
        textTransform: 'unset',
        '&:hover': {
          backgroundColor: "#F1F1F1"
        }
      },
    }
  },
  { name: "MetaData" }
);

export function MarketMetaData(props) {
  const {
    marketId,
    investibleId,
    stagesInfo,
    pageState,
    updatePageState,
    requiresCloseComments,
    stageId,
    formerStageId,
    assigned,
    isAssigned,
    isSingleUser,
    userId,
    tasksInProgress
  } = props;
  const intl = useIntl()
  const {
    showDiff
  } = pageState
  const history = useHistory();
  const [themeMode] = useContext(ThemeModeContext);
  const isDark = themeMode === 'dark';
  const [diffState, diffDispatch] = useContext(DiffContext);
  const [marketStagesState] = useContext(MarketStagesContext);
  const [messagesState] = useContext(NotificationsContext);
  const [operationRunning, setOperationRunning] = useContext(OperationInProgressContext);
  const [commentsState, commentsDispatch] = useContext(CommentsContext);
  const [, investiblesDispatch] = useContext(InvestiblesContext);
  const [, marketPresencesDispatch] = useContext(MarketPresencesContext);
  const myMessageDescription = findMessageOfTypeAndId(investibleId, messagesState, 'DESCRIPTION');
  const diff = getDiff(diffState, investibleId);
  const marketStages = getStages(marketStagesState, marketId);
  const fullStagesFiltered = marketStages.filter((fullStage) => fullStage.id === stageId || 
  (!fullStage.move_on_comment && (isAssigned || _.isEmpty(assigned) || !isAcceptedStage(fullStage))));
  const nextStage = nextStageField(getFullStage(marketStagesState, marketId, stageId), formerStageId, assigned,
    marketId, marketStagesState);
  const allowableStages = _.orderBy(fullStagesFiltered, (aStage) => {
    if (isFurtherWorkStage(aStage)) {
      return 0;
    }
    if (aStage.allows_investment) {
      return 1;
    }
    if (isAcceptedStage(aStage)) {
      return 2;
    }
    if (isInReviewStage(aStage)) {
      return 3;
    }
    return 4;
  });
  

  function toggleDiffShow() {
    updatePageState({showDiff: !showDiff});
  }

  // J-all-488: sets where the server returns this Debatable job once everything open on it is resolved
  function changeNextStage(nextStageId) {
    if (!nextStage || nextStageId === nextStage.value) {
      return;
    }
    setOperationRunning(true);
    return updateInvestible({ marketId, investibleId, formerStageId: nextStageId })
      .then((fullInvestible) => refreshInvestibles(investiblesDispatch, diffDispatch, [fullInvestible]))
      .finally(() => {
        setOperationRunning(false);
      });
  }
  const stageLink = formWizardLink(JOB_STAGE_WIZARD_TYPE, marketId, investibleId);

  function changeInvestibleStage(stageMoveId) {
    if (stageMoveId !== stageId) {
      const fullMoveStage = getFullStage(marketStagesState, marketId, stageMoveId);
      const requiresClose = requiresCloseComments(fullMoveStage);
      const requiresOtherAction = requiresAction(fullMoveStage, isSingleUser, stagesInfo.isBlocked);
      // A job with no assignee cannot legitimately enter a stage that takes an assignee (allows_assignment
      // covers exactly Work Ready, Waiting/Approval and Tasks Complete) so send it to the assignment wizard.
      // Single user keeps auto-assigning the mover to themselves in the direct path below.
      const requiresAssignment = !isSingleUser && _.isEmpty(assigned) && fullMoveStage.allows_assignment;
      const currentFullStage = getFullStage(marketStagesState, marketId, stageId) || {};
      // onInvestibleStageChange treats this argument as the stage being left. Passing the destination
      // reopens comments that Reviewable just closed (B-all-672).
      function applyMovedStage(newInv) {
        onInvestibleStageChange(fullMoveStage.id, newInv, investibleId, marketId, commentsState,
          commentsDispatch, investiblesDispatch, () => {}, marketStagesState, undefined, currentFullStage,
          marketPresencesDispatch);
      }
      function stageMoveInfo() {
        const moveInfo = {
          marketId,
          investibleId,
          stageInfo: {
            current_stage_id: stageId,
            stage_id: fullMoveStage.id
          },
        };
        if (isSingleUser && !isAssigned && fullMoveStage.allows_assignment) {
          moveInfo.stageInfo.assignments = [userId];
        }
        return moveInfo;
      }
      if (requiresClose || requiresOtherAction || requiresAssignment) {
        let fullStageLink = `${stageLink}&stageId=${stageMoveId}`;
        if (isSingleUser && !isAssigned && isAcceptedStage(fullMoveStage)) {
          fullStageLink += `&assignId=${userId}`;
        }
        if (stagesInfo.isInBlocked) {
          fullStageLink = `${fullStageLink}&isBlocked=true`;
        }
        if (requiresAssignment) {
          fullStageLink += '&isAssign=true';
        } else if (!requiresClose) {
          fullStageLink += '&isAssign=false';
        }
        // The approval wizard does not move the job. Change the stage first, then open that prompt.
        const moveBeforePrompt = !requiresClose && !requiresAssignment && !stagesInfo.isInBlocked &&
          fullMoveStage.allows_investment;
        if (moveBeforePrompt) {
          setOperationRunning(true);
          return stageChangeInvestible(stageMoveInfo())
            .then((newInv) => {
              applyMovedStage(newInv);
              navigate(history, fullStageLink);
            })
            .finally(() => setOperationRunning(false));
        }
        navigate(history, fullStageLink);
      } else {
        setOperationRunning(true);
        return stageChangeInvestible(stageMoveInfo())
          .then((newInv) => {
            applyMovedStage(newInv);
            if (!_.isEmpty(tasksInProgress) && fullMoveStage.allows_investment) {
              navigate(history, formWizardLink(IN_PROGRESS_WIZARD_TYPE, marketId, investibleId));
            }
          })
          .finally(() => setOperationRunning(false));
      }
    }
  }

  return (
    <div style={{marginBottom: '1.5rem'}}>
      {myMessageDescription && diff && (
        <>
          <SpinningIconLabelButton icon={showDiff ? ExpandLess : ExpandMoreIcon}
                                   iconColor={isDark ? DARK_ACTION_BUTTON_COLOR : undefined}
                                   onClick={toggleDiffShow} doSpin={false}>
            {intl.formatMessage({ id: showDiff ? 'diffDisplayDismissLabel' : 'diffDisplayShowLabel'})}
          </SpinningIconLabelButton>
          <div style={{paddingTop: '1.2rem'}} />
        </>
      )}
      {/* J-all-488: Next stage sits under Stage, never beside it */}
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1rem'}}>
      <FormControl>
        <b><FormattedMessage id={'allowedStagesDropdownLabel'}/></b>
        <Select
          value={stageId}
          onChange={(event) => changeInvestibleStage(event.target.value)}
        >
          {allowableStages.map((stage) => {
            return <MenuItem key={`key${stage.id}`} value={stage.id}>
              {getStageNameForId(marketStagesState, marketId, stage.id, intl)}</MenuItem>
          })}
        </Select>
      </FormControl>
      {nextStage && (
        <FormControl>
          <b><FormattedMessage id="nextStageDropdownLabel" /></b>
          <Select
            value={nextStage.value}
            onChange={(event) => changeNextStage(event.target.value)}
            disabled={operationRunning !== false}
          >
            {nextStage.optionIds.map((optionId) => (
              <MenuItem key={optionId} value={optionId}>
                {getStageNameForId(marketStagesState, marketId, optionId, intl)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      </div>
    </div>
  );
}

MarketMetaData.propTypes = {
  investibleId: PropTypes.string.isRequired,
  marketId: PropTypes.string.isRequired,
}
